import { useTranslation } from 'react-i18next';

/**
 * Resolves the active UI language to the two-letter key used by bilingual
 * (`{ en, ja }`) payloads from the backend. Centralises the `startsWith('ja')`
 * sniff so call sites don't each re-derive it.
 */
export function useLang(): 'en' | 'ja' {
  const { i18n } = useTranslation();
  return i18n.language.startsWith('ja') ? 'ja' : 'en';
}
